import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col } from 'react-bootstrap';

function NotificationModal({
  show,
  disabled,
  title,
  message,
  children,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs={12}>
            <p>{message}</p>
          </Col>
          {children && <Col xs={12}>{children}</Col>}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col xs={6}>
            <Button bsStyle="primary" onClick={onConfirm} block disabled={disabled}>
              {confirmText}
            </Button>
          </Col>
          <Col xs={6}>
            <Button bsStyle="default" onClick={onCancel} block disabled={disabled}>
              {cancelText}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

NotificationModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  show: PropTypes.bool,
  disabled: PropTypes.bool,
};

NotificationModal.defaultProps = {
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  show: false,
  disabled: false,
};

export default NotificationModal;
